<template>
  <modal name="registration-form" class="reg-modal registration-modal" width="500px" height="560px" :adaptive="true" :clickToClose="false">
    <div class="reg step-box">
      <form id="formReg" action="regUrl" class="reg-form" method="post">
        <button @click.prevent="hideForm()" class="pz-close-btn">
          <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
        </button>

        <div class="reg-form__header">Регистрация</div>
        <div class="input-wrapper">
          <input
            :class="{ hasError: this.loginError }"
            :value="login"
            @input="updateLogin"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[name]"
            placeholder="Фамилия Имя Отчество"
            type="text"
            :disabled="this.isRequested"
          />
          <span class="input-error" v-if="this.loginError">{{
            this.loginError
          }}</span>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.emailError }"
            :value="email"
            @input="updateEmail"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[email]"
            placeholder="Электронная почта"
            type="text"
            :disabled="this.isRequested"
          />
          <div v-if="this.emailError">
            <p class="input-error" v-html="emailError"></p>
          </div>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.phoneError }"
            :value="phone"
            @input="updatePhone"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[phone]"
            placeholder="Телефон в формате +7 (123) 456-78-90"
            type="text"
            v-mask="setting.currency === '₽' ? '+7 (###) ###-##-##' : '+375 (##) ###-##-##'"
            :disabled="this.isRequested"
          />
          <div v-if="this.phoneError">
            <p class="input-error" v-html="phoneError"></p>
          </div>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.birthdayError }"
            :value="birthday"
            @input="updateBirthday"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[birthday]"
            placeholder="Дата рождения в формате дд.мм.гггг"
            type="text"
            v-mask="'##.##.####'"
            :disabled="this.isRequested"
          />
          <div v-if="this.birthdayError">
            <p class="input-error" v-html="birthdayError"></p>
          </div>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.passwordError }"
            :value="password"
            @input="updatePassword"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[password]"
            placeholder="Пароль"
            type="password"
            :disabled="this.isRequested"
          />
          <span class="input-error" v-if="this.passwordError">{{
            this.passwordError
          }}</span>
        </div>

        <div class="input-wrapper">
          <input
            :class="{ hasError: this.repeatPasswordError }"
            :value="repeatPassword"
            @input="updateRepeatPassword"
            v-on:keydown.enter.prevent="submitReg"
            name="RegistrationForm[passwordRepeat]"
            placeholder="Повторите пароль"
            type="password"
            :disabled="this.isRequested"
          />
          <span class="input-error" v-if="this.repeatPasswordError">{{
            this.repeatPasswordError
          }}</span>
        </div>



        <div class="input-wrapper" v-if="this.isSmsCodeValidation">
          <p
            class="input-info input-sms-message"
            v-html="smsCodeMessage"
            v-if="this.smsCodeMessage"
          ></p>
          <input
            :class="'input-sms ' + { hasError: this.smsCodeError }"
            :value="smsCode"
            @input="updateSmsCode"
            v-on:keydown.enter.prevent="submitSmsCode"
            name="RegistrationForm[code]"
            placeholder=""
            v-mask="'#####'"
            type="text"
            :disabled="this.isRequested"
          />

          <span class="input-error" v-if="this.smsCodeError">{{
            this.smsCodeError
          }}</span>
        </div>

        <div class="input-wrapper" v-if="this.regErrors">
          <div
            class="input-error default-size"
            :key="idx"
            v-for="(error, idx) in this.regErrors"
          >
            <p v-html="error[0]"></p>
          </div>
        </div>

        <div class="input-wrapper" v-if="this.regError">
          <p class="input-error default-size" v-html="regError"></p>
        </div>

        <div class='isAccept-checkbox'>
          <label>
            <input class='checkbox' type='checkbox' v-model='isAccept'>
            <p>Принимаю <a @click.prevent='openUserAgreement' href='#'>Пользовательское соглашение</a></p>
          </label>
        </div>

        <div class="reg-form__footer">
          <input
            @click.prevent="submitSmsCode"
            v-on:keydown.enter.prevent="submitSmsCode"
            v-if="this.isSmsCodeValidation"
            class="basket-btn registration-btn registration-btn_small registration-btn_request"
            type="submit"
            value="Подтвердить код"
            data-toggle="modal"
            data-target="#regModal"
            :disabled="isRequested"
          />
          <input
            @click.prevent="submitReg"
            v-on:keydown.enter.prevent="submitReg"
            v-if="!this.isSmsCodeValidation"
            class="basket-btn registration-btn registration-btn_small registration-btn_request"
            type="submit"
            value="Зарегистрироваться"
            data-toggle="modal"
            data-target="#regModal"
            :disabled="isRequested && isAccept"
          />
          <div class="block-loading" v-if="this.isRequested"></div>
          <input
            @click.prevent="hideForm()"
            class="basket-btn registration-btn registration-btn_small registration-btn_cancel"
            type="button"
            value="Отмена"
            :disabled="isRequested"
          />
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
/* eslint-disable */

import axios from 'axios';
import { mask } from 'vue-the-mask';
import { setting } from '@/setting';
import { eventBus } from '@/main.js';
import { mapState } from 'vuex';
import { types } from '@/types';
import { fetchData } from '@/actions/identity';

export default {
  name: 'Registration',
  directives: { mask },
  props: ['disabled'],

  data() {
    return {
      /*csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute('content'),*/
      regUrl: '',
      completeUrl: '',
      login: '',
      email: '',
      phone: '',
      birthday: '',
      password: '',
      repeatPassword: '',
      loginError: '',
      emailError: '',
      phoneError: '',
      birthdayError: '',
      passwordError: '',
      repeatPasswordError: '',
      regError: '',
      regErrors: [],
      isRequested: false,
      isAccept: false,
      smsCode: '',
      isSmsCodeValidation: false,
      smsCodeMessage: '',
      smsCodeError: '',
    };
  },

  computed: {
    ...mapState(['setting', 'domain'])
  },

  created: function() {
    this.regUrl = this.domain + '/registration';
    this.completeUrl = this.domain + '/complete-registration';
  },

  methods: {
    openUserAgreement() {
      this.$modal.show('user-agreement');
      this.resetForm();
    },
    updateLogin(e) {
      this.login = e.target.value;
      this.validateLogin();
    },

    updateEmail(e) {
      this.email = e.target.value;
      this.validateEmail();
    },

    updatePhone(e) {
      this.phone = e.target.value;
      this.validatePhone();
    },


    updateBirthday(e) {
      this.birthday = e.target.value;
      this.validateBirthday();
    },

    updatePassword(e) {
      this.password = e.target.value;
      this.validatePassword();
    },

    updateRepeatPassword(e) {
      this.repeatPassword = e.target.value;
      this.validateRepeatPassword();
    },

    updateSmsCode(e) {
      this.smsCode = e.target.value;
      this.validateSmsCode();
    },

    validateLogin() {
      if (!this.login) {
        this.loginError = 'Необходимо заполнить Фамилию Имя Отчество';
        return false;
      }
      this.loginError = false;
      return true;
    },

    validateEmail() {
      if (!this.email) {
        this.emailError = 'Необходимо заполнить Email';
        return false;
      }
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email)) {
        this.emailError = 'Некорректный ввод Email';
        return false;
      }
      this.emailError = false;
      return true;
    },

    validatePhone() {
      if (!this.phone) {
        this.phoneError = 'Необходимо заполнить телефон';
        return false;
      }
      this.phoneError = false;
      return true;
    },

    validateBirthday() {
      if (!this.birthday) {
        this.birthdayError = 'Необходимо заполнить дату рождения';
        return false;
      }
      this.birthdayError = false;
      return true;
    },

    validatePassword() {
      if (!this.password) {
        this.passwordError = 'Необходимо заполнить пароль';
        return false;
      }
      this.passwordError = false;
      return true;
    },

    validateRepeatPassword() {
      if (!this.repeatPassword) {
        this.repeatPasswordError = 'Необходимо еще раз написать пароль';
        return false;
      }
      this.repeatPasswordError = false;
      return true;
    },

    validateSmsCode() {
      if (this.isSmsCodeValidation) {
        if (!this.smsCode) {
          this.smsCodeError = 'Необходимо указать код из СМС';
          return false;
        }
      }
      this.smsCodeError = false;
      return true;
    },

    validateForm(e) {
      this.validateLogin();
      this.validateEmail();
      this.validatePhone();
      this.validateBirthday();
      this.validatePassword();
      this.validateRepeatPassword();
      this.validateSmsCode();
      if (!this.isFormFilledCorrectly()) {
        e.preventDefault();
        return false;
      }
      return true;
    },

    clearErrors() {
      this.loginError = '';
      this.emailError = '';
      this.phoneError = '';
      this.birthdayError = '';
      this.passwordError = '';
      this.repeatPasswordError = '';
      this.regError = '';
      this.regErrors = [];
      this.smsCodeError = '';
    },

    resetForm() {
      this.clearErrors();

      this.login = '';
      this.email = '';
      this.phone = '';
      this.birthday = '';
      this.password = '';
      this.repeatPassword = '';
      this.isRequested = false;
      this.smsCode = '';
      this.isSmsCodeValidation = false;
      this.smsCodeMessage = '';
    },

    submitSmsCode(e) {
      if (!this.validateForm(e)) return;

      this.isRequested = true;
      this.isSmsCodeValidation = true;
      const bodyFormData = this.createFormData(this.smsCode);

      this.clearErrors();

      axios({
        method: 'post',
        url: this.completeUrl,
        data: bodyFormData,
        withCredentials: true,
      })
        .then(response => {
          this.isRequested = false;

          console.log('response completed', response)

          if (response.data.success) {
            this.isSmsCodeValidation = true;

            const bodyFormData = new FormData();
            bodyFormData.set('AuthForm[username]', this.phone);
            bodyFormData.set('AuthForm[password]', this.password);


            axios({
              method: 'post',
              url: setting.authHost + '/auth/async',
              data: bodyFormData,
              withCredentials: true,
            })
              .then(response => {
                console.log(response, 'response from signin')
                if (response.data.success) {
                  console.log(response.data.token)
                  this.$cookie.set("i", response.data.token, { expires: 30, domain: '.premierzal.ru', sameSite: 'None', secure: '' })
                  let token = response.data.token || this.$cookie.get('i');
                  this.$store.commit(types.SET_ID_TOKEN, token);

                  fetchData(token).then(user => {
                    console.log(user, 'user');
                    //debugger;

                    user.isRegistrationInWidget = true
                    this.$store.commit(types.SET_USER_DATA, user);
                    let cardNumber =
                      user && user.profile && user.publicId
                        ? user.publicId
                        : 'карта отсутствует';
                    this.$store.dispatch('logUser', {
                      changes: `Получен пользователь ${user.profile.name} <br>Email: ${user.email}. <br>Номер карты: ${cardNumber}`,
                      status: 'up',
                    });

                    this.$store.dispatch('fetchCustomerAccounts');
                    this.$modal.hide('modal-card');

                    this.hideForm()
                  });
                } else {
                  console.log('error')
                }
              })
              .catch(error => {
                //console.log(error);
                throw error;
              });



            let onSuccess = function(sender, response) {
              console.log('onSuccess')
              sender.hideForm();
            };
            let onError = function(sender, response) {
              console.log('onError')

              if (response && response.data && !response.data.success) {
                if (response.data.error) {
                  sender.regError = response.data.error;
                } else if (response.data.errors) {
                  sender.regError = response.data.errors[0];
                }
                sender.regError =
                  sender.regError || 'Произошла непредвиденная ошибка';
              }
            };

            console.log('before emit')

            eventBus.$emit(
              'signIn',
              this,
              this.phone,
              this.password,
              onSuccess,
              onError,
            );

            return;
          }

          this.processResponseErrors(response);
        })
        .catch(error => {
          console.log(error);
          this.isRequested = false;
          throw error;
        });
    },

    createFormData(smsCode) {
      const bodyFormData = new FormData();
      bodyFormData.set('RegistrationForm[name]', this.login);
      bodyFormData.set('RegistrationForm[email]', this.email);
      bodyFormData.set('RegistrationForm[phone]', this.phone);
      bodyFormData.set('RegistrationForm[birthday]', this.birthday);
      bodyFormData.set('RegistrationForm[password]', this.password);
      bodyFormData.set('RegistrationForm[passwordRepeat]', this.repeatPassword);
      bodyFormData.set('RegistrationForm[code]', smsCode);
      return bodyFormData;
    },

    submitReg(e) {
      if (!this.isAccept) return
      if (!this.validateForm(e)) return;

      const bodyFormData = this.createFormData();
      this.isRequested = true;
      this.isSmsCodeValidation = false;

      this.clearErrors();

      if (this.domain) {
        axios({
          method: 'post',
          url: this.regUrl,
          data: bodyFormData,
          withCredentials: true,
        })
          .then(response => {
            this.isRequested = false;

            if (response.data.success) {
              this.isSmsCodeValidation = true;
              this.smsCodeMessage = response.data.message;
              return;
            }

            this.processResponseErrors(response);
          })
          .catch(error => {
            this.isRequested = false;

            throw error;
          });
      }
    },

    processResponseErrors(response) {
      if (response && response.data && !response.data.success) {
        if (response.data.errors) {
          this.regErrors = response.data.errors;
        } else {
          this.regError =
            response.data.error || 'Произошла непредвиденная ошибка';
        }
      }
    },

    isFormFilledCorrectly() {
      return (
        this.login &&
        this.email &&
        this.phone &&
        this.birthday &&
        this.password &&
        this.repeatPassword &&
        !(
          this.loginError ||
          this.emailError ||
          this.phoneError ||
          this.birthdayError ||
          this.passwordError ||
          this.repeatPasswordError
        ) &&
        (this.isSmsCodeValidation ? this.smsCode && !this.smsCodeError : true)
      );
    },

    hideForm() {
      this.$modal.hide('registration-form');
      this.resetForm();
    },
  },
};
</script>

<style lang="scss">
.registration-modal .v--modal-box.v--modal {
  position: relative !important;
  width: auto !important;
  min-width: 200px !important;
  max-width: calc(90vw - 30px) !important;
  min-height: 200px !important;
  height: auto !important;
  max-height: calc(90vh - 30px) !important;
  padding: 10px !important;
  z-index: 99999 !important;
  display: block;
}

.reg {
  margin: 0 !important;
  padding: 15px !important;
  height: 100% !important;

  &-form {
    width: 100%;
    max-width: 400px;
    flex-direction: column;

    &__header {
      font-size: 20px;
      text-align: center;
      color: #ffffff;
      margin-top: 20px;
      margin-bottom: 20px;
    }

    &__footer {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      position: relative;
    }
  }

  &.step-box {
    position: relative;
    border: none;

    .input-wrapper {
      .input-sms {
        width: 100px;
        margin: 0 auto;
        display: block;
      }
    }

    .input-error {
      color: white !important;
      margin: 10px 0;
      font-size: 14px !important;

      a {
        color: white;
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}

.registration-btn {
  &_request {
    width: 100%;
    margin: 0 20px 0 0;
  }

  &_small {
    height: 45px;
    border: none;
    text-transform: none;
    border-radius: 8px;

    &:focus {
      outline: none;
    }
  }
}

.basket-btn_alt_close {
  position: absolute;
  top: -5px;
  right: 5px;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  background: transparent;
  border: 1px solid #ccc;
  transform: rotate(45deg);
}

.basket-btn_alt_close::before,
.basket-btn_alt_close::after {
  position: absolute;
  left: 22px;
  content: ' ';
  height: 24px;
  width: 2px;
  background-color: #ccc;
  top: 10px;
}

.basket-btn_alt_close::before {
  transform: rotate(45deg);
}

.basket-btn_alt_close:hover {
  opacity: 1;
}

.input-info.input-sms-message {
  text-align: left;
  padding: 10px 0 15px 0;
}

.reg {
  .pz-close-btn {
    top: 10px;
    right: 10px;
  }
}

.v--modal-overlay .v--modal-box {
  overflow: auto !important;
  height: auto !important;
}

.isAccept-checkbox {
  label {
    display: flex;
    align-items: center;
    justify-content: center;

    .checkbox {
      width: 1rem;
      height: 1rem;
      margin-right: .5rem;
    }

    p {
      margin: 0;
      font-size: .9rem;
      opacity: 0.9;

      a {
        color: rgba(255, 255, 255, 0.7);
        text-decoration: underline;
      }
    }
  }
}

@media only screen and (max-width: 768px), only screen and (max-width: 768px) and (max-height: 650px) {
  .registration-modal .v--modal-box.v--modal {
    position: relative !important;
    width: auto !important;
    min-width: 200px !important;
    max-width: calc(90vw - 30px) !important;
    min-height: 200px !important;
    height: auto !important;
    max-height: calc(90vh - 30px) !important;
    padding: 10px !important;
    z-index: 99999 !important;
    display: block;
  }
}

@media only screen and (max-width: 480px) {
  .registration-modal .reg-modal .v--modal {
    position: relative !important;
    width: auto !important;
    min-width: 200px !important;
    max-width: calc(90vw - 30px) !important;
    height: auto !important;
    min-height: 200px;
    max-height: calc(90vh - 30px) !important;
    padding: 10px !important;
    z-index: 99999 !important;
    display: block;
    &-form {
      width: 100% !important;
    }
  }

  .reg {
    width: calc(100% - 30px);
    padding-top: 0 !important;
    &-form {
      width: auto !important;
      min-width: auto !important;
    }
  }

  .reg-form__footer {
    flex-direction: column !important;

    .registration-btn_cancel {
      display: none;
    }
  }
}

@media only screen and (max-height: 480px) {
  .registration-modal .v--modal-box.v--modal {
    position: relative !important;
    height: auto !important;
    min-height: 180px;
    max-height: calc(90vh - 30px) !important;
    padding: 10px !important;
    z-index: 99999 !important;
    display: block;
  }
}
</style>
